/* eslint-disable max-lines */
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import { getAddressFromPlace } from '@tcp/core/src/utils';
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import validatorMethods from '@tcp/core/src/utils/formValidation/validatorMethods';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import { getEcomSkuParams } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormSection, reduxForm, touch } from 'redux-form';
import { setSessionStorage } from '@tcp/core/src/utils/utils.web';
import RegisteredShippingFormV2 from '../../../Checkout/organisms/ShippingPage/organisms/RegisteredShippingForm/views/RegisteredShippingFormV2';
import ShipmentMethods from '../../../common/molecules/SPCShipmentMethods';
import {
  ADDRESS_FORM_MODE,
  SHIPPING_FIELD_ADDRESS_LINE_1,
  SHIPPING_FIELD_ADDRESS_LINE_2,
} from '../../container/Shipping/Shipping.constants';
import { isCanada } from '../../../../../../utils';
import { SECTION_MODE } from '../../container/SinglePageCheckout.constants';
import ShippingAddressForm from '../Shipping/ShippingAddressForm.view';
import checkoutUtil, { scrollToFirstErrorSPC } from '../../../Checkout/util/utility';
import { getUserLastName, getUserName } from '../../../../account/User/container/User.selectors';
import { setContactFormValuesInSS } from '../ContactForm/ContactForm.util';
import { handleShakeSaveAndContinueOnSpc } from '../../../../../../utils/utils';
import ShippingPageLabels, {
  SHIPPING_LABELS,
} from '../../../Checkout/organisms/ShippingPage/views/ShippingPage.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';

const { hasPOBox } = checkoutUtil;

export const getInitialValues = (ownProps) => {
  const {
    savedAddress: {
      id,
      addressId,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      zipCode,
      city,
      state,
      phone: phoneNumber,
      phoneCountryCode,
      validationCode,
    },
    selectedShipmentId,
    shipmentMethods,
    contactFormData: { smsSignUp, emailSignUp, emailAddress },
    phoneNumberForReg,
  } = ownProps;
  return {
    id,
    addressId,
    firstName,
    lastName,
    searchAddress: '',
    addressLine1,
    addressLine2,
    zipCode,
    city,
    state,
    country: isCanada() ? 'CA' : 'US',
    phoneNumber: phoneNumberForReg || phoneNumber,
    shipmentMethods: { shippingMethodId: selectedShipmentId || shipmentMethods?.[0]?.id },
    smsSignUp,
    emailSignUp,
    emailAddress,
    phoneCountryCode,
    validationCode,
  };
};

class ShippingForm extends React.Component {
  shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);

  constructor(props) {
    super(props);
    this.state = {
      isAddNewAddress: false,
      isEditing: false,
      editShipmentDetailsError: '',
    };
    this.isAddressModalEmptied = false;
    this.addNewAddressEnabled = false;
    this.editShippingErrorRef = React.createRef();
    this.previousPOBoxStatus = false;
  }

  componentDidMount() {
    const {
      dispatchFormFieldChange,
      defaultFirstName,
      defaultLastName,
      initialValues,
      shippingAddress: { addressLine1 = '', addressLine2 = '' } = {},
      isInternationalPhoneNumberEnabled,
    } = this.props;
    this.previousPOBoxStatus = hasPOBox(addressLine1, addressLine2);
    dispatchFormFieldChange('firstName', defaultFirstName || initialValues?.firstName || '');
    dispatchFormFieldChange('lastName', defaultLastName || initialValues?.lastName || '');
    dispatchFormFieldChange('country', isCanada() ? 'CA' : 'US');
    dispatchFormFieldChange('phoneNumber', initialValues?.phoneNumber || '');
    if (isInternationalPhoneNumberEnabled) {
      dispatchFormFieldChange('phoneCountryCode', initialValues?.phoneCountryCode || '');
    }
  }

  toggleAddNewAddress = () => {
    const { isAddNewAddress } = this.state;
    this.setState({ isAddNewAddress: !isAddNewAddress });
  };

  /**
   * @function handleShipIntClick
   * function to open country selector popup on shipping page
   */
  handleShipIntClick = (e) => {
    const { toggleCountrySelector } = this.props;
    e.preventDefault();
    toggleCountrySelector({ isModalOpen: true });
  };

  updateShippingForm = ({
    city,
    zipCode,
    state,
    addressLine1,
    addressLine2,
    mode: newMode,
    shouldRevalidate,
  }) => {
    const { formName, dispatch, dispatchFormFieldChange, updateSectionState, loadShipmentMethods } =
      this.props;
    dispatchFormFieldChange('city', city);
    dispatchFormFieldChange('zipCode', zipCode);
    dispatchFormFieldChange('state', state);
    dispatchFormFieldChange('addressLine1', addressLine1);
    dispatchFormFieldChange('addressLine2', addressLine2);
    dispatchFormFieldChange('country', isCanada() ? 'CA' : 'US');
    updateSectionState({ autoSuggestMode: newMode });
    if (shouldRevalidate) {
      dispatch(touch('addressLine1', 'city', 'state', 'zipCode'));
    }
    if (state) {
      const requestPayload = {
        state,
        zipCode,
        addressField1: addressLine1,
        addressField2: addressLine2,
        formName,
      };
      loadShipmentMethods(requestPayload);
    }
  };

  handlePlaceSelectedGmaps = (place, inputValue) => {
    const { updateSectionState } = this.props;
    const address = getAddressFromPlace(place, inputValue);
    const { street: addressLine1, addressLine2, city, state, zip: zipCode } = address || {};
    this.updateShippingForm({
      city,
      zipCode,
      state,
      addressLine1,
      addressLine2,
      mode: ADDRESS_FORM_MODE.MANUAL,
      shouldRevalidate: true,
    });
    updateSectionState({ isFormExpanded: true, isMethodAndGiftSectionVisible: true });
  };

  handlePlaceSelected = (address) => {
    const { updateSectionState } = this.props;
    const { addressline: addressLine1, addressLine2, city, state, zip: zipCode } = address || {};
    this.updateShippingForm({
      city,
      zipCode,
      state,
      addressLine1,
      addressLine2,
      mode: ADDRESS_FORM_MODE.MANUAL,
      shouldRevalidate: true,
    });
    updateSectionState({ isFormExpanded: true, isMethodAndGiftSectionVisible: true });
  };

  fillFormManually = () => {
    const { updateSectionState, shippingFormInput: { addressLine1 = '', addressLine2 = '' } = {} } =
      this.props;
    this.updateShippingForm({
      mode: ADDRESS_FORM_MODE.MANUAL,
      addressLine1,
      addressLine2,
    });
    updateSectionState({
      isFormExpanded: true,
      isMethodAndGiftSectionVisible: true,
    });
  };

  changeAddress = (event, key) => {
    const {
      formName,
      loadShipmentMethods,
      shippingFormInput: {
        addressLine1 = '',
        addressLine2 = '',
        city = '',
        state = '',
        zipCode = '',
        country = '',
      } = {},
      section,
      updateSectionState,
    } = this.props;
    // Check if entered address is a POBox address
    const currentPOBoxStatus = hasPOBox(addressLine1, addressLine2);
    // Check if POBox has been either added or removed
    // In both cases, we need to re-fetch the shipment methods
    if (currentPOBoxStatus !== this.previousPOBoxStatus) {
      const newValue = event.target.value;
      loadShipmentMethods({
        addressField1: key === SHIPPING_FIELD_ADDRESS_LINE_1 ? newValue : addressLine1,
        addressField2: key === SHIPPING_FIELD_ADDRESS_LINE_2 ? newValue : addressLine2,
        city,
        state,
        zipCode,
        country,
        formName,
      });
      // Save history of currentPOBoxStatus flag
      this.previousPOBoxStatus = currentPOBoxStatus;
    }
    if (key === SHIPPING_FIELD_ADDRESS_LINE_1 && !section?.isFormExpanded) {
      // Show full form(all fields) when addressLine1 is changed and it is not already expanded
      updateSectionState({
        isFormExpanded: true,
        isMethodAndGiftSectionVisible: true,
      });
    }
  };

  changeZipCode = (event) => {
    const zipCodeValue = typeof event === 'object' ? event.target.value : event;
    const {
      formName,
      shippingFormInput,
      shippingFormInput: { addressLine1 = '', addressLine2 = '' } = {},
      getZipCodeSuggestedAddress,
      cartOrderItems,
      currentOrderId,
      eddAllowedStatesArr,
      clearEddTTLActn,
    } = this.props;
    const skuData = (cartOrderItems && getEcomSkuParams(cartOrderItems)) || [];
    const orderId = currentOrderId.toString();
    if (
      shippingFormInput &&
      validatorMethods.zipcode(zipCodeValue, null, null, [shippingFormInput.country])
    ) {
      clearEddTTLActn();
      getZipCodeSuggestedAddress({
        zipCodeValue,
        addressLine1,
        addressLine2,
        formName,
        shouldLoadShipmentMethods: true,
        skuData,
        orderId,
        eddAllowedStatesArr,
      });
    }
  };

  changeShipmentMethods = (e, value) => {
    const { formName, loadShipmentMethods, clearEddTTLActn } = this.props;
    const { shippingFormInput: { addressLine1, addressLine2, zipCode = '' } = {} } = this.props;
    if (loadShipmentMethods) {
      clearEddTTLActn();
      loadShipmentMethods({
        state: value,
        addressField1: addressLine1,
        addressField2: addressLine2,
        zipCode,
        formName,
      });
    }
  };

  handleClickOutside = () => {
    const { clickedOutsideShipping } = this.props;
    handleShakeSaveAndContinueOnSpc(clickedOutsideShipping, true);
  };

  render() {
    const {
      formName,
      formSection,
      addressFormLabels,
      dispatch,
      mapboxSwitch,
      mapboxAutocompleteTypesParam,
      shippingFormInput,
      mode,
      handleSave,
      shipmentMethods,
      selectedShipmentId,
      isLoadingShippingMethods,
      isUpdatingShipmentMethods,
      isGuestUser,
      isMobile,
      isSaveToAddressBookChecked,
      shippingAddressId,
      updateShippingAddress,
      addNewShippingAddress,
      labels,
      shippingAddress,
      syncErrorsObject,
      address,
      zipCodeABTestEnabled,
      getZipCodeSuggestedAddress,
      zipCodeLoader,
      isEDD,
      updateEdd,
      cartOrderItems,
      eddAllowedStatesArr,
      currentOrderId,
      formMetaInfo,
      formSyncError,
      resetShippingEddData,
      submitErrors,
      checkoutServerError,
      dispatchFormFieldChange,
      updateSectionState,
      savedAddress,
      loadShipmentMethods,
      globalLabels,
      section,
      orderEddDates,
      smsSignUpLabels,
      isUsSite,
      emailSignUpFlags,
      emailSignUpLabels,
      emailSignUpCaRichText,
      isChildrenPalace,
      isGymboree,
      isSnJ,
      initialValues,
      isLoginV2FlowEnabled,
      savedEmail,
      emailFailSafe,
      venmoStatus,
      isPlccIC,
      shippingFormValues,
      shippingState,
      holidayMessageEnabled,
      freeShippingThershold,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      orderType,
      productTotal,
      isInternationalPhoneNumberEnabled,
      className,
      setPhoneCountryAction,
      orderTrackingEnhancementEnabled,
    } = this.props;
    const { isEditing, editShipmentDetailsError, isAddNewAddress } = this.state;
    const addressFormFieldClass = mode === ADDRESS_FORM_MODE.AUTO_SUGGEST ? 'hidden-field' : '';
    return (
      <>
        {isGuestUser && (
          <ShippingAddressForm
            formName={formName}
            section={section}
            addressFormLabels={addressFormLabels}
            formSection={formSection}
            shippingFormInput={shippingFormInput}
            mapboxSwitch={mapboxSwitch}
            mapboxAutocompleteTypesParam={mapboxAutocompleteTypesParam}
            handlePlaceSelected={this.handlePlaceSelected}
            handlePlaceSelectedGmaps={this.handlePlaceSelectedGmaps}
            fillFormManually={this.fillFormManually}
            handleSave={handleSave}
            addressFormFieldClass={addressFormFieldClass}
            zipCodeABTestEnabled={zipCodeABTestEnabled}
            changeZipCode={this.changeZipCode}
            changeShipmentMethods={this.changeShipmentMethods}
            changeAddress={this.changeAddress}
            smsSignUpLabels={smsSignUpLabels}
            isUsSite={isUsSite}
            emailSignUpFlags={emailSignUpFlags}
            emailSignUpLabels={emailSignUpLabels}
            emailSignUpCaRichText={emailSignUpCaRichText}
            isSnJ={isSnJ}
            isGymboree={isGymboree}
            isChildrenPalace={isChildrenPalace}
            initialValues={initialValues}
            isLoginV2FlowEnabled={isLoginV2FlowEnabled}
            savedEmail={savedEmail}
            emailFailSafe={emailFailSafe}
            venmoStatus={venmoStatus}
            isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
            dispatchFormFieldChange={dispatchFormFieldChange}
            className={className}
            defaultPhoneNumber={initialValues?.phoneNumber}
            defaultCountryCode={initialValues?.phoneCountryCode}
            isPlccIC={isPlccIC}
            setPhoneCountryAction={setPhoneCountryAction}
            orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
          />
        )}
        {!isGuestUser && (
          <RegisteredShippingFormV2
            {...this.props}
            formName={formName}
            section={section}
            savedAddress={savedAddress}
            addressLabels={addressFormLabels}
            isEditing={isEditing}
            isMobile={isMobile}
            dispatch={dispatch}
            isAddNewAddress={isAddNewAddress}
            toggleAddNewAddress={this.toggleAddNewAddress}
            isSaveToAddressBookChecked={isSaveToAddressBookChecked}
            shippingAddressId={shippingAddressId}
            updateShippingAddress={updateShippingAddress}
            addNewShippingAddress={addNewShippingAddress}
            shippingAddress={shippingAddress}
            labels={labels}
            afterAddressUpdate={this.closeEditingMode}
            setDefaultAddressId={this.setDefaultAddressId}
            syncErrorsObject={syncErrorsObject}
            errorMessageRef={this.editShippingErrorRef}
            editShipmentDetailsError={editShipmentDetailsError}
            handleShipIntClick={this.handleShipIntClick}
            address={address}
            zipCodeABTestEnabled={zipCodeABTestEnabled}
            getZipCodeSuggestedAddress={getZipCodeSuggestedAddress}
            zipCodeLoader={zipCodeLoader}
            updateEdd={updateEdd}
            isEDD={isEDD}
            cartOrderItems={cartOrderItems}
            eddAllowedStatesArr={eddAllowedStatesArr}
            currentOrderId={currentOrderId}
            formMetaInfo={formMetaInfo}
            formSyncError={formSyncError}
            submitErrors={submitErrors}
            resetShippingEddData={resetShippingEddData}
            checkoutServerError={checkoutServerError}
            clearServerError={this.clearServerError}
            handleSave={handleSave}
            addressFormFieldClass={addressFormFieldClass}
            shippingFormInput={shippingFormInput}
            dispatchFormFieldChange={dispatchFormFieldChange}
            updateSectionState={updateSectionState}
            handlePlaceSelected={this.handlePlaceSelected}
            handlePlaceSelectedGmaps={this.handlePlaceSelectedGmaps}
            loadShipmentMethods={loadShipmentMethods}
            changeZipCode={this.changeZipCode}
            fillFormManually={this.fillFormManually}
            changeShipmentMethods={this.changeShipmentMethods}
            globalLabels={globalLabels}
            changeAddress={this.changeAddress}
            smsSignUpLabels={smsSignUpLabels}
            isUsSite={isUsSite}
            emailSignUpFlags={emailSignUpFlags}
            emailSignUpLabels={emailSignUpLabels}
            emailSignUpCaRichText={emailSignUpCaRichText}
            isSnJ={isSnJ}
            isGymboree={isGymboree}
            isChildrenPalace={isChildrenPalace}
            initialValues={initialValues}
            isLoginV2FlowEnabled={isLoginV2FlowEnabled}
            savedEmail={savedEmail}
            emailFailSafe={emailFailSafe}
            venmoStatus={venmoStatus}
            isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
            className={className}
            defaultPhoneNumber={initialValues?.phoneNumber}
            defaultCountryCode={initialValues?.phoneCountryCode}
            isPlccIC={isPlccIC}
            setPhoneCountryAction={setPhoneCountryAction}
            orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
          />
        )}
        {!isEmpty(shipmentMethods) && !isPlccIC && (
          <Row fullBleed>
            <Col
              colSize={{ small: 6, medium: 8, large: 12 }}
              className={`${!section?.isMethodAndGiftSectionVisible ? 'hidden-field' : ''}`}
            >
              <FormSection name="shipmentMethods">
                <ShipmentMethods
                  shipmentMethods={shipmentMethods}
                  shipmentMethodsSize={shipmentMethods?.length}
                  formName={formName}
                  formSection="shipmentMethods"
                  selectedShipmentId={selectedShipmentId}
                  shipmentHeader={renderLabel(
                    this.shippingPageLabels?.lbl_shipping_shipmentHeader,
                    'lbl_shipping_shipmentHeader'
                  )}
                  isLoadingShippingMethods={isLoadingShippingMethods}
                  isUpdatingShipmentMethods={isUpdatingShipmentMethods}
                  dispatchFormFieldChange={dispatchFormFieldChange}
                  checkoutRoutingDone
                  isEDD
                  isEddABTest
                  currentShipmentId={shippingFormInput?.shipmentMethods?.shippingMethodId}
                  orderEddDates={orderEddDates}
                  sectionMode={section?.mode}
                  shippingFormValues={shippingFormValues}
                  shippingState={shippingState}
                  holidayMessageEnabled={holidayMessageEnabled}
                  freeShippingThershold={freeShippingThershold}
                  shippingTotal={shippingTotal}
                  isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
                  shipments={shipments}
                  orderType={orderType}
                  productTotal={productTotal}
                  isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
                />
              </FormSection>
            </Col>
          </Row>
        )}
      </>
    );
  }
}

ShippingForm.propTypes = {
  formName: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  formSection: PropTypes.string,
  mapboxSwitch: PropTypes.bool,
  mapboxAutocompleteTypesParam: PropTypes.string,
  shippingFormInput: PropTypes.shape({}),
  addressFormLabels: PropTypes.shape({}).isRequired,
  mode: PropTypes.string.isRequired,
  updateSectionState: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  dispatchFormFieldChange: PropTypes.func.isRequired,
  shipmentMethods: PropTypes.shape([]),
  selectedShipmentId: PropTypes.string,
  isLoadingShippingMethods: PropTypes.bool,
  isUpdatingShipmentMethods: PropTypes.bool,
  loadShipmentMethods: PropTypes.func.isRequired,
  updateShipmentMethods: PropTypes.func.isRequired,
  isGuestUser: PropTypes.bool.isRequired,
  section: PropTypes.shape({}).isRequired,
  clearEddTTLActn: PropTypes.func.isRequired,
};

ShippingForm.defaultProps = {
  formSection: '',
  mapboxSwitch: false,
  mapboxAutocompleteTypesParam: '',
  shippingFormInput: {},
  shipmentMethods: null,
  isLoadingShippingMethods: false,
  isUpdatingShipmentMethods: false,
  selectedShipmentId: '',
};

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps?.formName,
    initialValues: getInitialValues(ownProps),
    defaultFirstName: getUserName(state),
    defaultLastName: getUserLastName(state),
  };
};

const validateMethod = createValidateMethod(
  getStandardConfig([
    'firstName',
    'lastName',
    'addressLine1',
    'addressLine2',
    'city',
    'state',
    'zipCode',
    'country',
    'phoneNumber',
    'emailAddress',
  ])
);

const onSubmit = (values, dispatch, props) => {
  const {
    handleSaveAndContinueShipping,
    giftServicesInput,
    isLoginV2FlowEnabled,
    savedEmail,
    emailFailSafe,
    venmoStatus,
    isMakeDefaultUxUpdateEnabled,
    isDefaultChanged,
    orderTrackingEnhancementEnabled,
    smsCheckBoxState,
  } = props;
  const { emailAddress } = values;
  const payloadForShipping = {
    isExpanded: false,
    mode: SECTION_MODE.SECTION_VIEW_MODE,
    savedAddress: {
      ...values,
      ...(isMakeDefaultUxUpdateEnabled && isDefaultChanged
        ? { defaultShipping: isDefaultChanged }
        : {}),
    },
    giftServicesDetails: { ...giftServicesInput },
  };
  if (orderTrackingEnhancementEnabled) {
    if (payloadForShipping.savedAddress.phoneCountryCode === '+1') {
      payloadForShipping.savedAddress.smsSignUp = { sendOrderUpdate: smsCheckBoxState };
    } else {
      payloadForShipping.savedAddress.smsSignUp = { sendOrderUpdate: false };
    }
    payloadForShipping.isFormExpanded = false;
  }
  handleSaveAndContinueShipping(payloadForShipping);
  if (isLoginV2FlowEnabled && (!savedEmail || emailFailSafe || venmoStatus)) {
    setContactFormValuesInSS({ emailAddress });
    if (!savedEmail) setSessionStorage({ key: 'emailForFailSafe', value: true });
  }
};

ShippingForm.propTypes = {
  isMobile: PropTypes.bool,
  isSaveToAddressBookChecked: PropTypes.bool,
  shippingAddressId: PropTypes.string,
  updateShippingAddress: PropTypes.func.isRequired,
  addNewShippingAddress: PropTypes.func.isRequired,
  labels: PropTypes.shape({}).isRequired,
  shippingAddress: PropTypes.shape({}).isRequired,
  syncErrorsObject: PropTypes.shape({}),
  address: PropTypes.shape({}),
  zipCodeABTestEnabled: PropTypes.bool,
  getZipCodeSuggestedAddress: PropTypes.func.isRequired,
  zipCodeLoader: PropTypes.bool,
  isEDD: PropTypes.bool,
  updateEdd: PropTypes.func.isRequired,
  cartOrderItems: PropTypes.shape({}),
  eddAllowedStatesArr: PropTypes.string,
  currentOrderId: PropTypes.string,
  formMetaInfo: PropTypes.shape({}),
  formSyncError: PropTypes.shape({}),
  resetShippingEddData: PropTypes.func.isRequired,
  submitErrors: PropTypes.shape({}),
  checkoutServerError: PropTypes.shape({}),
  dispatchFormFieldChange: PropTypes.func.isRequired,
  updateSectionState: PropTypes.func.isRequired,
  savedAddress: PropTypes.shape({}),
  ServerErrors: PropTypes.shape({}),
  addItemToSflList: PropTypes.func.isRequired,
  isGuest: PropTypes.bool,
  toggleCountrySelector: PropTypes.func.isRequired,
  userAddresses: PropTypes.shape({}).isRequired,
  setEditShippingFlag: PropTypes.func.isRequired,
  globalLabels: PropTypes.shape({}),
  orderEddDates: PropTypes.shape({}),
};

ShippingForm.defaultProps = {
  isMobile: false,
  isSaveToAddressBookChecked: false,
  shippingAddressId: '',
  syncErrorsObject: {},
  address: {},
  zipCodeABTestEnabled: false,
  zipCodeLoader: false,
  isEDD: false,
  cartOrderItems: {},
  eddAllowedStatesArr: '',
  currentOrderId: '',
  formMetaInfo: {},
  formSyncError: {},
  submitErrors: {},
  checkoutServerError: {},
  savedAddress: {},
  ServerErrors: {},
  isGuest: false,
  globalLabels: {},
  orderEddDates: {},
};

const Submiterror = (errors, dispatch, submitError, props) => {
  scrollToFirstErrorSPC(errors);
  props.clickedOutsideShipping(true);
  setTimeout(() => props.clickedOutsideShipping(false), 1000);
};

export default connect(mapStateToProps)(
  reduxForm({
    onSubmit,
    ...validateMethod,
    onSubmitFail: Submiterror,
  })(ShippingForm)
);
// eslint-disable-next-line max-lines
export { ShippingForm as ShippingFormVanilla };
